module.exports = __webpack_public_path__ + "static/media/icon_info.a3ff4255.png";